module.exports = __webpack_public_path__ + "img/contentIcon.f18f85e5.png";